import React, { useEffect, useContext, createContext, useState } from 'react';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import {
  AgeGroup,
  Disclaimer,
  Emergency,
  // HomePage,
  Questions,
  Splashscreen,
  Symptom,
  FinalMessage,
  Language,
  Onboarding,
  OtherSymptom,
  Agreement,
  PrivacyPolicy,
  TermsAndConditions,
  Menu,
  Output,
  Feedback,
  Loading,
  ErrorHandler,
  ClinicalFeedback,
  SpinWheel,
  // Static pages
  HomeStaticPage,
  OnboardingSetupStaticPage,
  SymptomsStaticPage,
  VaccinationStaticPage,
  ChildProgressStaticPage,
  FirstAidChild,
  FirstAidAdult,
  HomeEmergency,
  NewSkillsStaticPage,
  SkillStaticPage,
  Assessment,
  SignsAndSymptomsAdultOptions,
  SignsAndSymptoms,
  MilestoneCheckerStaticPage
} from './pages';
import MetricsContextProvider from './context/MetricsContextProvider';
import ThemeContext from './context/ThemeContext';
import CookieConsent from './components/CookieConsent/CookieConsent';
import { applyStoredCookieConsent } from './utils/cookieConsent';
import { getUserLocation, reverseGeocode, storeResolvedLocationData } from './utils';
import ManagePermissions from './pages/ManagePermissions/ManagePermissions';
import Layout from './Layout';
import Adventure from './staticPages/Adventure';

function AppContent() {
  return (
    <>
      <Routes>
        {/* pages without footer */}
        <Route exact path="/" element={<Splashscreen />} />
        <Route exact path="/welcome" element={<OnboardingSetupStaticPage />} />
        <Route exact path="/onboarding" element={<Onboarding />} />
        <Route exact path="/loading" element={<Loading />} />
        <Route exact path="/error" element={<ErrorHandler />} />
        {/* Pages with footer */}
        <Route element={<Layout />}>
          {/* <Route exact path="/homepage" element={<HomePage />} /> */}
          <Route exact path="/homepage" element={<HomeStaticPage />} />
          <Route exact path="/disclaimer" element={<Disclaimer />} />
          <Route exact path="/ageGroup" element={<AgeGroup />} />
          <Route exact path="/emergency" element={<Emergency />} />
          <Route exact path="/symptoms" element={<SignsAndSymptomsAdultOptions />} />
          <Route exact path="/questions" element={<Questions />} />
          <Route exact path="/finalMessage" element={<FinalMessage />} />
          <Route exact path="/output" element={<Output />} />
          <Route exact path="/otherSymptom" element={<OtherSymptom />} />
          <Route exact path="/agreement" element={<Agreement />} />
          <Route exact path="/policy" element={<PrivacyPolicy />} />
          <Route exact path="/terms" element={<TermsAndConditions />} />
          <Route exact path="/language" element={<Language />} />
          <Route exact path="/menu" element={<Menu />} />
          <Route exact path="/feedback" element={<Feedback />} />
          <Route exact path="/clinicalFeedback/:researchId" element={<ClinicalFeedback />} />
          <Route exact path="/spin-wheel" element={<SpinWheel />} />
          <Route exact path="/permissions" element={<ManagePermissions />} />
          <Route exact path="/vaccination" element={<VaccinationStaticPage />} />
          <Route exact path="/childProgress" element={<ChildProgressStaticPage />} />
          <Route exact path="/firstAid/:id" element={<FirstAidChild />} />
          <Route exact path="/firstaid-adult" element={<FirstAidAdult />} />
          <Route exact path="/adventure" element={<Adventure />} />
          <Route exact path="/home-emergency" element={<HomeEmergency />} />
          <Route exact path="/assessment" element={<Assessment />} />
          <Route exact path="/assessment-symptoms" element={<Symptom />} />
          <Route exact path="/childProgress/milestone-check" element={<MilestoneCheckerStaticPage />} />
          <Route exact path="/new-skills" element={<NewSkillsStaticPage />} />
          <Route exact path="/new-skills/:skill" element={<SkillStaticPage />} />
          <Route exact path="/signs-symptoms/:id" element={<SignsAndSymptoms />} />
        </Route>
      </Routes>
      <CookieConsent />
    </>
  );
}

function App() {
  const { theme, toggleTheme } = useContext(ThemeContext);
  console.log(theme)

  useEffect(() => {
    applyStoredCookieConsent();

    const fetchLocationData = async () => {
      const location = getUserLocation();
      if (location) {
        const data = await reverseGeocode(location.latitude, location.longitude);
        storeResolvedLocationData(data);
      }
    };
    fetchLocationData().catch((error) => {
      console.error('Error fetching location data:', error);
    });
  }, []);
  return (
    <MetricsContextProvider>
      <div className="app" id={theme}>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AppContent />
        </Router>
      </div>
    </MetricsContextProvider>
  );
}

export default App;
